import { ReactNode } from 'react';

interface DroppableColumnProps {
  title: string;
  isDraggingOver: boolean;
  children: ReactNode;
}

export default function DroppableColumn({ title, isDraggingOver, children }: DroppableColumnProps) {
  return (
    <div>
      <h4 className="mb-3">{title}</h4>
      <div
        style={{
          width:'300px',
          minHeight: '210px', 
          padding: '16px',
          backgroundColor: isDraggingOver ? 'lightblue' : 'rgb(245, 245, 245)',
          borderRadius: '1rem',
          boxShadow: isDraggingOver ? '0 4px 6px rgba(0,0,0,0.1)' : 'none',
          display: 'flex',
          flexDirection: 'column',
          gap: '16px'
        }}
        className="border border-light" // Para agregar borde liviano
      >
        {children}
      </div>
    </div>
  );
}